(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-category-games/assets/javascripts/page-category-games.js') >= 0) return;  svs.modules.push('/components/casino-react/page-category-games/assets/javascripts/page-category-games.js');

'use strict';

const {
  useEffect,
  useMemo
} = React;
const {
  useParams
} = ReactRouterDOM;
const ErrorPage = svs.components.casino_react.page_error;
const {
  GridDisplayModes
} = svs.components.casino_react.common.constants;
const {
  CasinoSection
} = svs.components.casino_react.casinoSection;
const {
  cmsCategoryList,
  cmsLiveCategoryList
} = svs.casino_react.shared.data;
const {
  setMetaTags
} = svs.components.lbUtils.setMetaTags;
const {
  SubHeader
} = svs.components.casino_react.sub_header;
const {
  useSearchResults
} = svs.components.casino_react.casinoStore.hooks;
const {
  useSetSearchParams
} = svs.components.casino_react.hooks;
const {
  FilterAndSort
} = svs.components.casino_react.filterAndSort;
const actionButtons = () => React.createElement(FilterAndSort, null);
const PageCategoryGames = () => {
  const {
    categoryType,
    categoryName
  } = useParams();
  const {
    setListIds
  } = useSetSearchParams();
  const contentList = useMemo(() => categoryType === 'live' ? cmsLiveCategoryList : cmsCategoryList, [categoryType]);
  const categoryModel = useMemo(() => {
    var _contentList$find$mod, _contentList$find;
    return (_contentList$find$mod = (_contentList$find = contentList.find(game => game.model.systemName === categoryName)) === null || _contentList$find === void 0 ? void 0 : _contentList$find.model) !== null && _contentList$find$mod !== void 0 ? _contentList$find$mod : {};
  }, [categoryName, contentList]);
  useEffect(() => {
    if (categoryModel.contentList) {
      setListIds([categoryModel.contentList]);
    }
  }, [categoryModel.contentList]);
  const {
    games,
    error,
    isLoading,
    isFetching,
    totalGamesCount,
    fetchMore
  } = useSearchResults();
  useEffect(() => {
    setMetaTags({
      docTitle: categoryModel.metaTitle,
      metaDesc: categoryModel.metaDescription
    });
  }, [categoryModel.metaTitle, categoryModel.metaDescription]);
  if (error) {
    return React.createElement(ErrorPage, null);
  }
  if (!(categoryModel !== null && categoryModel !== void 0 && categoryModel.contentList)) {
    return React.createElement("p", {
      className: "align-center margin-top-4 category-not-found"
    }, "Vi hittade inga resultat f\xF6r kategori:", ' ', React.createElement("span", {
      className: "f-italic bold"
    }, categoryName));
  }
  return React.createElement(React.Fragment, null, React.createElement(SubHeader, {
    title: categoryModel.name
  }), React.createElement(CasinoSection, {
    ActionButtons: actionButtons,
    displayMode: GridDisplayModes.GRID_UNRESTRICTED,
    fetchMore: fetchMore,
    isLoading: isLoading || isFetching,
    isSearchResult: (games === null || games === void 0 ? void 0 : games.length) === 0,
    items: games ? games : [],
    title: totalGamesCount ? "".concat(totalGamesCount, " spel") : '',
    totalGamesCount: totalGamesCount
  }));
};
setGlobal('svs.components.casino_react.pageCategoryGames.PageCategoryGames', PageCategoryGames);

 })(window);